import type { FaireProductEntity } from "../../entity_types/product";

export const p_9u5nyftcfr: FaireProductEntity = {
  token: "p_9u5nyftcfr",
  type: "product",
  name: "Wild and Free Cactus Desert Adventure Tee",
  brandToken: "b_uyrp83b3tq",
  brandName: "Soleinspire",
  imageUrl:
    "https://cdn.faire.com/fastly/1c14b0940a179bd24b7a0b527b46a9c213ea7c52b38f831d7ed0eb6e8b296f21.webp",
  galleryImageUrls: [],
  priceDollars: 14.55,
  description:
    "Experience ultimate comfort with this high-quality Bella Canvas 3001 tee. Featuring a unique Wild and Free graphic, this shirt is perfect for nature lovers and free spirits. Its soft fabric ensures a great fit for everyday wear. Ideal for outdoor adventures, road trips, and casual outings. Stand out from the crowd with this stylish cactus and sunrise design on a comfortable t-shirt. Perfect as a gift for adventure seekers or as a staple in your own wardrobe.\nTags- graphic tee, nature t-shirt, outdoor clothing, adventure tee, cactus shirt, desert style, boho chic, wild and free, travel apparel, unisex fashion, comfortable tee, soft t-shirt, casual wear, mountain design, sun graphic, bohemian style, wanderlust clothing, scenic print, road trip shirt, gift idea",
  tags: [],
  msrpDollars: 36.03,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:10.524Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
